<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">PLANILLA DE LANZAMIENTO</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040 Rev. 2
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> CUIT: {{ cuit }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Dirección: {{ direccion }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Localidad: {{ localidad }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <h6> Contacto Comercial: {{ contactocom }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Teléfono Comercial: {{ telcom }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Mail Comercial: {{ mailcom }}</h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <h6> Contacto Técnico: {{ contactotec }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Teléfono Técnico: {{ teltec }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Mail Técnico: {{ mailtec }}</h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="2">
                                    <h6> N° OC: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="2">
                                    <h6> Fecha OC: {{ fechaoc }} </h6>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <h6> Descripción: {{ provision }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    <h6 color="black"><b>Responsable Comercial: {{ responsable }}
                                        </b>
                                    </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <v-radio-group color="red darken-3" v-model="tipooc" row dense>
                                        <v-radio color="red darken-3" dense label="Material" value="M"></v-radio>
                                        <v-radio color="red darken-3" dense label="Fabricación" value="F"></v-radio>
                                        <v-radio color="red darken-3" dense label="Obra" value="O"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <h6 color="black"> Monto sin IVA: {{ monto }}<b></b></h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <h6 color="black"> Moneda: {{ moneda }}<b></b></h6>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>

                            <v-row dense>
                                <v-col cols="12" sm="6" md="4">
                                    Referente de Proyecto: {{ lider }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Responsable de Producción: {{ respprod }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    Responsable de Obra: {{ respobra }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5" v-if="tipo == 'F' || tipo == 'M'">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    Intervención Calidad?: {{ calidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Contacto para Inspección: {{ contactocalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Teléfono de Contacto: {{ telcalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Mail de Contacto: {{ mailcalidad }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5" v-if="tipo == 'O'">
                        <v-card-text>
                            <v-row dense>

                                <v-col cols="12" sm="6" md="4">
                                    Inspector/es: {{ contactocalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Teléfono de Contacto: {{ telcalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Mail de Contacto: {{ mailcalidad }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="2">
                                    N° de OT: {{ numot }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    N° de Obra: {{ codobra }}
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    N° de Carpeta en Directorio Obra: {{ carpetaobra }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Minuta de Reunión de Lanzamiento: {{ minuta }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headersOC" :items="listadooc" locale="es-ar" height="180"
                                fixed-header :items-per-page="200" hide-default-footer class="pa-0 ma-0"
                                :item-class="setRowStyle"></v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="3" md="1">
                                    Forma de Pago:
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Anticipo: {{ anticipo }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Contra Entrega: {{ entrega }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Certificaciones: {{ certific }}
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    Otros: {{ otros }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="4">
                                    Plazo de Pago: {{ plazo }} días
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    A partir de: {{ condicion }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="3" md="3">
                                    N° de Presupuesto: {{ presupuesto }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Carpeta: {{ carpeta }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Alternativa: {{ alternativa }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Presupuesto Proveedores: {{ presupprove }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="1" md="1">
                                    Ensayos: {{ ensayo }}
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    Tipo de Ensayo: {{ tipoensayo }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Entrega </b></h6>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    Lugar: {{ lugar }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    Fecha de Entrega: {{ fechaentrega }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    Forma: {{ forma }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    Tipo de Embalaje: {{ embalaje }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">

                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">
                                            Tranporte a cargo de: {{ transporte }}
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" md="12">
                                            Realizó Reunión: {{ reunion }}

                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-data-table dense :headers="headers" :items="listadoentregas" locale="es-ar"
                                        height="150" fixed-header :items-per-page="200" hide-default-footer
                                        class="pa-0 ma-0" :item-class="setRowStyle">
                                    </v-data-table>

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headersP" :items="listadoproducto" locale="es-ar" height="200"
                                fixed-header :items-per-page="200" hide-default-footer class="pa-0 ma-0"
                                :item-class="setRowStyle">
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="mostrarobra == true">
                        <v-card-text>
                            <h6>Datos para Antecendentes de Obras:</h6>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="4">
                                    Nombre de la obra: {{ obra }}
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Ubicación: {{ ubicacion }}
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Comitente: {{ comitente }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Breve descripción de la obra: {{ descripcionobra }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="3">
                                    Monto de Obra Original: {{ montoobra }}
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    Plazo de Obra Original en días: {{ plazoobra }}
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    Adenda de Obra: {{ adendamonto }}
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    Adenda de Plazo: {{ adendaplazo }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="4">
                                    Fecha firma de Contrato: {{ fechacontrato }}
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Fecha inicio de Obra: {{ fechainicio }}
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Fecha final de Obra: {{ fechafinal }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="4">
                                    Participación %: {{ participacion }}
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Especialidad %: {{ especialidad1 }} - {{ porcespec1 }} %
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    Especialidad %: {{ especialidad2 }} - {{ porcespec2 }} %
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- <v-card color="#e6b0aa">
                        <v-card-text>

                            <v-row dense>
                                <v-col cols="12" sm="6" md="4">
                                    Referente de Proyecto: {{ lider }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Responsable de Producción: {{ respprod }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    Responsable de Obra: {{ respobra }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5" v-if="tipo == 'F' || tipo == 'M'">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    Intervención Calidad?: {{ calidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Contacto para Inspección: {{ contactocalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Teléfono de Contacto: {{ telcalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Mail de Contacto: {{ mailcalidad }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5" v-if="tipo == 'O'">
                        <v-card-text>
                            <v-row dense>

                                <v-col cols="12" sm="6" md="4">
                                    Inspector/es: {{ contactocalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Teléfono de Contacto: {{ telcalidad }}
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    Mail de Contacto: {{ mailcalidad }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="2">
                                    N° de OT: {{ numot }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    "N° de Obra: {{ codobra }}
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    N° de Carpeta en Directorio Obra: {{ carpetaobra }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Minuta de Reunión de Lanzamiento: {{ minuta }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card> -->
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Listado de Ensayos </b></h6>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>De Rutina</b></h6>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>Especiales</b></h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="r1" label="Análisis de aceite por PCBs." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r2" label="Constructivo." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r3" label="Dimensional." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r4" label="Discordancia de polos de interruptor."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r5" label="Funcional eléctrico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r6" label="Funcional mecánico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r7" label="Hermeticidad." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r8" label="Pintura." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="r9" label="Puesta a tierra." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="r10" label="Relación de transformación." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r11" label="Resistencia eléctrica de aislación."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r12" label="Resistencia eléctrica de polos." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r13" label="Resistividad de terreno." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r14" label="Rigidez dieléctrica." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r15" label="Rigidez dieléctrica de aceite." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r16" label="Tiempos de apertura y cierre de interruptor."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r17" label="Tiempos de disparo de interruptor." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="e1" label="Arco interno." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e2" label="Calentamiento." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e3" label="Corriente resistida de breve duración."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e4" label="Corriente resistida de cresta." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e5" label="Cortocircuito." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e6" label="Descargas parciales." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e7" label="Factor de potencia." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e8" label="Grado de protección mecánica (IP)." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="e9" label="Impulso atmosférico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e10" label="Impacto." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="e11" label="Pérdidas en carga y tensión de impedancia."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e12" label="Pérdidas en vacío y corriente de excitación."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e13" label="Resistencia eléctrica de bobinados."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e14" label="Sísmico." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="e15" label="Tensión inducida." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="2" v-if="protocolo1 == 'ON'">
                                    Protocolo de ensayo: {{ protocolo1 }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="protocolo2 == 'ON'">
                                    Protocolo de ensayo: {{ protocolo2 }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="protocolo3 == 'ON'">
                                    Protocolo de ensayo: {{ protocolo3 }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="protocolo4 == 'ON'">
                                    Protocolo de ensayo: {{ protocolo4 }}
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="protocolo5 == 'ON'">
                                    Protocolo de ensayo: {{ protocolo5 }}
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text v-for="(item, index) in listado" :key="index">
                            <v-row dense>
                                <v-col cols="12" sm="2" md="2">
                                    Entrega: {{ item.entrega }}
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    Item: {{ item.item }}
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    Camión: {{ item.camion }}
                                </v-col>
                                <v-col cols="12" sm="1" md="1">
                                    Bultos: {{ item.bultos }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    Detalle Bultos:
                                    <p style="white-space: pre-line;">{{ item.detallebultos }}</p>
                                </v-col>
                            </v-row>
                            <!-- </v-card-text>
                    </v-card> -->
                            <v-card color="#f2d7d5">
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-row dense>
                                                Transporte a cargo de ICSSA: {{ item.transporte }}
                                            </v-row>
                                            <v-row dense>
                                                Seguro: {{ item.seguro }}
                                            </v-row>
                                            <v-row dense>
                                                Descarga: {{ item.descarga }}
                                            </v-row>
                                            <v-row dense>
                                                Lugar de Entrega: {{ item.lugar }}
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-row dense>
                                                Remito: {{ item.remito }}
                                            </v-row>
                                            <v-row dense>
                                                Nota de Envío: {{ item.nota }}
                                            </v-row>
                                            <v-row dense>
                                                Factura: {{ item.factura }}
                                            </v-row>
                                            <v-row dense>
                                                Transporte usado por el Cliente: {{ item.transpcliente }}
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="2">
                                            <v-row dense>
                                                Fecha Necesidad (flete): {{ item.fecha }}
                                            </v-row>
                                            <v-row dense>
                                                Monto de la Carga (U$S): {{ item.montocarga }}
                                            </v-row>
                                            <v-row dense>
                                                Monto a Asegurar (U$S): {{ item.montoasegurar }}
                                            </v-row>
                                            <v-row dense>
                                                Póliza: 01-03-12-30009461
                                            </v-row>
                                            <v-row dense>
                                                Monto Asegurado: U$S 200.000,00 + IVA
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-row dense>
                                                Detalle Remito: {{ item.detalleremito }}
                                            </v-row>
                                            <v-row dense>
                                                Detalle Factura: {{ item.detallefactura }}
                                            </v-row>
                                            <v-row dense>
                                                Costo Flete: {{ item.costoflete }}
                                            </v-row>
                                            <v-row dense>
                                                Costo Descarga: {{ item.costodescarga }}
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="2" md="3">
                                            Transporte Contratado: {{ item.transporteabast }}
                                        </v-col>
                                        <v-col cols="12" sm="2" md="3">
                                            Guía de Despacho: {{ item.guiaabast }}
                                        </v-col>
                                        <v-col cols="12" sm="2" md="3">
                                            Fecha envío: {{ item.fechaabast }}
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="2" md="3">
                                            Factura: {{ item.facturaadm }}
                                        </v-col>
                                        <v-col cols="12" sm="2" md="3">
                                            Remito: {{ item.remitoadm }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>

                        </v-card-text>
                    </v-card>
                    <!-- </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card> -->

                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data() {
        return {
            codgral: "",
            codoc: "",
            visible: true,
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            fact: "",
            cuit: "",
            domicilio: "",
            localidad: "",
            contactocom: "",
            contactotec: "",
            telcom: "",
            teltec: "",
            mailcom: "",
            mailtec: "",
            provision: "",
            responsable: "",
            tipo: "",
            tipooc: "",
            fechaoc: "",
            monto: "",
            moneda: "",
            itemmoneda: [
                { nombre: "Pesos", valor: "P" },
                { nombre: "Dólares", valor: "D" },
            ],
            itemensayo: [
                { nombre: "Rutina", valor: "R" },
                { nombre: "Rutina/Especiales", valor: "RE" },
                { nombre: "Especiales", valor: "E" },
            ],
            //fecha: moment().format("DD/MM/YYYY"),
            headersOC: [{
                text: "Item",
                align: "start",
                sortable: false,
                value: "item",
                width: "10%"
            },
            { text: "Detalle", value: "descr", sortable: false, width: "50%" },
            { text: "Cantidad", value: "cantidad", sortable: false, width: "10%" },
            { text: "Precio Unitario Dólares", value: "precio", sortable: false, width: "15%" },
            { text: "Precio Unitario Pesos", value: "precio", sortable: false, width: "15%" },
            ],
            headers: [{
                text: "Fecha",
                align: "start",
                sortable: false,
                value: "fecha",
                width: "30%"
            },
            { text: "Descripción entrega / Item", value: "descr", sortable: false, width: "70%" },
            ],
            headersP: [{
                text: "Tipo de Producto",
                align: "start",
                sortable: false,
                value: "producto"
            },
            { text: "Modelo", value: "modelo", sortable: false },
            { text: "Función", value: "funcion", sortable: false },
            { text: "Tensión", value: "tension", sortable: false },
            { text: "Potencia", value: "potencia", sortable: false },
            { text: "I Bus Barra", value: "ibb", sortable: false },
            { text: "Icc", value: "icc", sortable: false },
            { text: "I Nominal", value: "inominal", sortable: false },
            { text: "Observaciones", value: "observ", sortable: false },
            { text: "Cantidad", value: "cantidad", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
            ],
            listadooc: [{ item: "", descr: "", cantidad: "", precio: "" },
            { item: "", descr: "", cantidad: "", precio: "" },
            { item: "", descr: "", cantidad: "", precio: "" },],
            listadoentregas: [{ fecha: "", descr: "" },
            { fecha: "", descr: "" },
            { fecha: "", descr: "" },
            { fecha: "", descr: "" },
            ],
            listadoproducto: [],
            listadotipo: [],
            listadomodelo: [],
            listadofuncion: [],
            anticipo: "",
            entrega: "",
            certific: "",
            otros: "",
            plazo: "",
            condicion: "",
            presupuesto: "",
            carpeta: "",
            alternativa: "",
            presupprove: "",
            ensayo: "",
            tipoensayo: "",
            lugar: "",
            fechaentrega: "",
            forma: "",
            embalaje: "",
            transporte: "",
            total: "",
            cantidad: "",
            reunion: "",
            estado: "",
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
            entregas: [],
            detalleoc: [],
            comercial: [],
            listentrega: [],
            listoc: [],
            listadop: [],
            dialogDelete: false,
            editedIndex: -1,
            editedItem: {
                producto: "",
                modelo: "",
                funcion: "",

            },
            mostrarobra: false,
            ubicacion: "",
            obra: "",
            descripcion: "",
            comitente: "",
            montoobra: "",
            plazoobra: "",
            adendamonto: "",
            adendaplazo: "",
            fechacontrato: "",
            fechainicio: "",
            fechafinal: "",
            participacion: "",
            especialidad1: "",
            especialidad2: "",
            itemespecialidad: [
                { nombre: "Arquitectura", valor: "Arquitectura" },
                { nombre: "Ingeniería Eléctrica", valor: "Ingeniería Eléctrica" },
                { nombre: "Ingeniería Mecánica", valor: "Ingeniería Mecánica" },
                { nombre: "Saneamiento", valor: "Saneamiento" },
                { nombre: "Red de Gas", valor: "Red de Gas" },
                { nombre: "Pavimentos Rígidos", valor: "Pavimentos Rígidos" },
                { nombre: "Pavimentos Flexibles", valor: "Pavimentos Flexibles" },
                { nombre: "Hidráulica", valor: "Hidráulica" },
                { nombre: "Obras Básicas", valor: "Obras Básicas" },
                { nombre: "Obras de Arte", valor: "Obras de Arte" },
            ],
            porcespec1: "",
            porcespec2: "",
            antecobra: [],
            descr: "",
            fecha: "",
            fechaabastecimiento: "",
            fechacalidad: "",
            cantidad: "",
            tipo: "",
            numot: "",
            r1: "",
            r2: "",
            r3: "",
            r4: "",
            r5: "",
            r6: "",
            r7: "",
            r8: "",
            r9: "",
            r10: "",
            r11: "",
            r12: "",
            r13: "",
            r14: "",
            r15: "",
            r16: "",
            r17: "",
            e1: "",
            e2: "",
            e3: "",
            e4: "",
            e5: "",
            e6: "",
            e7: "",
            e8: "",
            e9: "",
            e10: "",
            e11: "",
            e12: "",
            e13: "",
            e14: "",
            e15: "",
            protocolo1: "",
            protocolo2: "",
            protocolo3: "",
            protocolo4: "",
            protocolo5: "",
            listado: [{ id: "0", entrega: "1", item: "", camion: "", bultos: "", estado: "", detallebultos: "" },
            ],
            listadodespacho: [],
            //fecha: "",
            fechaentrega: "",
            prorroga: "",
            listadoprorroga: [
                { nombre: 'No Solicitada' },
                { nombre: 'Solicitada' },
                { nombre: 'Otorgada' },
            ],
            fechaprorroga: "",
            diasprorroga: "",
            respobra: "",
            respprod: "",
            lider: "",
            calidad: "",
            contactocalidad: "",
            mailcalidad: "",
            telcalidad: "",
            numotdesde: "",
            numothasta: "",
            carpetaobra: "",
            codobra: "",
            minuta: "",
            despacho: "",
            estado: "",
            listadoestado: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            headers: [
                { text: "Entrega", value: "entrega", sortable: false, width: "5%" },
                { text: "Item", value: "item", sortable: false },
                { text: "Tipo y Cantidad de Camiones", value: "camion", sortable: false, width: "25%" },
                { text: "Total de Bultos", value: "bultos", sortable: false, width: "7%" },
                { text: "Estado", value: "estado", sortable: false, width: "15%" },

            ],
            deshabilitar: false,
            expanded: [],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
            montoasegurado: "",
            poliza: ""
        };
    },

    // props: ["visible", "codgral", "codoc"],
    computed: {

        show: {
            get() {
                // if (this.visible == true) {
                //     this.cargardatosOC();
                //     this.cargardatosEjecucion();
                //     this.cargardatosCalidad();
                //     this.cargardatosAbastecimiento();
                // }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    },

    methods: {
        setRowStyle(item) {
            return 'style-1'
        },
        cargardatosOC() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            this.loadtable = true;
            let self = this;
            axios
                .get("/Lanzamiento/CargarOC?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.fact = response.data.fact;
                    self.empresa = response.data.empresa;
                    self.cuit = response.data.cuit;
                    self.domicilio = response.data.domicilio;
                    self.localidad = response.data.localidad;
                    self.contactocom = response.data.contactocom;
                    self.telcom = response.data.telcom;
                    self.mailcom = response.data.mailcom;
                    self.contactotec = response.data.contactotec;
                    self.teltec = response.data.teltec;
                    self.mailtec = response.data.mailtec;
                    self.provision = response.data.provision;
                    self.responsable = response.data.responsable;
                    self.tipooc = response.data.tipo;
                    self.monto = response.data.monto;
                    self.moneda = response.data.moneda;
                    self.fechaoc = response.data.fecha;
                    self.anticipo = response.data.anticipo;
                    self.entrega = response.data.entrega;
                    self.certific = response.data.certific;
                    self.otros = response.data.otros;
                    self.plazo = response.data.plazo;
                    self.condicion = response.data.condicion;
                    self.presupuesto = response.data.presupuesto;
                    self.carpeta = response.data.carpeta;
                    self.alternativa = response.data.alternativa;
                    self.presupprove = response.data.presupprove;
                    self.ensayo = response.data.ensayo;
                    self.tipoensayo = response.data.tipoensayo;
                    self.lugar = response.data.lugar;
                    self.fechaentrega = response.data.fechaentrega;
                    self.forma = response.data.forma;
                    self.embalaje = response.data.embalaje;
                    self.transporte = response.data.transporte;
                    self.total = response.data.total;
                    self.cantidad = response.data.cantidad;
                    self.reunion = response.data.reunion;
                    self.estado = response.data.estado;
                    self.listadoentregas = response.data.entregas;
                    self.listadooc = response.data.detalleoc;
                    response.data.producto.forEach((element) => {
                        self.listadoproducto.push({
                            producto: element.producto,
                            modelo: element.modelo,
                            funcion: element.funcion,
                            tension: element.tension,
                            potencia: element.potencia,
                            ibb: element.ibb,
                            icc: element.icc,
                            inominal: element.inominal,
                            observ: element.observ,
                            cantidad: element.cantidad,
                            filteredModelos: response.data.producto
                                .filter(prod => prod.modelo === element.modelo)
                                .map(prod => prod.modelo),
                            filteredFuncion: response.data.producto
                                .filter(prod => prod.funcion === element.funcion)
                                .map(prod => prod.funcion),
                        });
                        if (element.producto == "Obras") {
                            self.mostrarobra = true;
                            self.obra = response.data.antecedentes.obra;
                            self.ubicacion = response.data.antecedentes.ubicacion;
                            self.comitente = response.data.antecedentes.comitente;
                            self.descripcion = response.data.antecedentes.descripcion;
                            self.montoobra = response.data.antecedentes.montoobra;
                            self.plazoobra = response.data.antecedentes.plazoobra;
                            self.adendamonto = response.data.antecedentes.adendamonto;
                            self.adendaplazo = response.data.antecedentes.adendaplazo;
                            self.fechacontrato = response.data.antecedentes.fechacontrato;
                            self.fechainicio = response.data.antecedentes.fechainicio;
                            self.fechafinal = response.data.antecedentes.fechafinal;
                            self.participacion = response.data.antecedentes.participacion;
                            self.especialidad1 = response.data.antecedentes.especialidad1;
                            self.especialidad2 = response.data.antecedentes.especialidad2;

                        }
                    })

                    self.loadtable = false;
                    // if (self.listadooc.length == 0) {
                    //     self.listadooc = [{ item: "", descr: "", cantidad: "", precio: "" },
                    //     { item: "", descr: "", cantidad: "", precio: "" },
                    //     { item: "", descr: "", cantidad: "", precio: "" },]
                    // }
                    // if (self.listadoentregas.length == 0) {
                    //     self.listadoentregas = [{ fecha: "", descr: "" },
                    //     { fecha: "", descr: "" },
                    //     { fecha: "", descr: "" },
                    //     { fecha: "", descr: "" },
                    //     ]
                    // }
                    // if (self.listadoproducto.length == 0) {
                    //     self.listadoproducto = [{ producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                    //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                    //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                    //     { producto: "", modelo: "", funcion: "", tension: "", potencia: "", ibb: "", icc: "", inominal: "", observ: "", cantidad: "" },
                    //     ]
                    // }

                    console.log("LISTADO", self.listadoproducto)
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargardatosEjecucion() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarEjecucion?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.tipo = response.data.tipo;
                    //self.fecha = response.data.fecha;
                    self.fechaentrega = response.data.fechaentrega;
                    self.prorroga = response.data.prorroga;
                    self.fechaprorroga = response.data.fechaprorroga;
                    self.diasprorroga = response.data.diasprorroga;
                    self.lider = response.data.lider;
                    self.respobra = response.data.respobra;
                    self.respprod = response.data.respprod;
                    self.minuta = response.data.minuta;
                    self.calidad = response.data.calidad;
                    self.contactocalidad = response.data.contacto;
                    self.telcalidad = response.data.tel;
                    self.mailcalidad = response.data.mail;
                    self.numot = response.data.numot;
                    self.numotdesde = response.data.numot.substring(0, 5);
                    self.numothasta = response.data.numot.substring(8, 13);
                    self.carpetaobra = response.data.carpeta;
                    self.codobra = response.data.codobra;
                    self.estado = response.data.estado;
                    self.fechaestado = response.data.fechaestado;
                    self.despacho = response.data.despacho;

                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargardatosCalidad() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarCalidad?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.fechacalidad = response.data.fecha;
                    self.r1 = response.data.r1;
                    self.r2 = response.data.r2;
                    self.r3 = response.data.r3;
                    self.r4 = response.data.r4;
                    self.r5 = response.data.r5;
                    self.r6 = response.data.r6;
                    self.r7 = response.data.r7;
                    self.r8 = response.data.r8;
                    self.r9 = response.data.r9;
                    self.r10 = response.data.r10;
                    self.r11 = response.data.r11;
                    self.r12 = response.data.r12;
                    self.r13 = response.data.r13;
                    self.r14 = response.data.r14;
                    self.r15 = response.data.r15;
                    self.r16 = response.data.r16;
                    self.r17 = response.data.r17;
                    self.e1 = response.data.e1;
                    self.e2 = response.data.e2;
                    self.e3 = response.data.e3;
                    self.e4 = response.data.e4;
                    self.e5 = response.data.e5;
                    self.e6 = response.data.e6;
                    self.e7 = response.data.e7;
                    self.e8 = response.data.e8;
                    self.e9 = response.data.e9;
                    self.e10 = response.data.e10;
                    self.e11 = response.data.e11;
                    self.e12 = response.data.e12;
                    self.e13 = response.data.e13;
                    self.e14 = response.data.e14;
                    self.e15 = response.data.e15;
                    self.protocolo1 = response.data.protocolo1;
                    self.protocolo2 = response.data.protocolo2;
                    self.protocolo3 = response.data.protocolo3;
                    self.protocolo4 = response.data.protocolo4;
                    self.protocolo5 = response.data.protocolo5;
                    //self.numot = response.data.numot;
                    self.estado = response.data.estado;

                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        cargardatosAbastecimiento() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarAbastecimiento?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.fechaabastecimiento = response.data.fecha;
                    self.estado = response.data.estado;
                    self.cantidad = response.data.cantidad;
                    self.tipo = response.data.tipo;
                    self.descr = response.data.descr;
                    self.listado = response.data.despacho;


                }
                )
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },


        vaciarListado() {
            this.empresa = "";
            this.provision = "";
            this.fact = "";
            this.cuit = "";
            this.domicilio = "";
            this.localidad = "";
            this.contactocom = "";
            this.contactotec = "";
            this.telcom = "";
            this.teltec = "";
            this.mailcom = "";
            this.mailtec = "";
            this.responsable = "";
            this.tipo = "";
            this.monto = "";
            this.moneda = "";
            this.itemmoneda = [];
            this.itemensayo = [];
            this.fecha = "";
            this.fechacalidad = "";
            this.fechaabastecimiento = "";
            this.listadooc = [];
            this.listadoentregas = [];
            this.listadoproducto = [];
            this.listadotipo = [];
            this.listadomodelo = [];
            this.listadofuncion = [];
            this.anticipo = "";
            this.entrega = "";
            this.certific = "";
            this.otros = "";
            this.plazo = "";
            this.condicion = "";
            this.presupuesto = "";
            this.carpeta = "";
            this.alternativa = "";
            this.presupprove = "";
            this.ensayo = "";
            this.tipoensayo = "";
            this.lugar = "";
            this.fechaentrega = "";
            this.forma = "";
            this.embalaje = "";
            this.transporte = "";
            this.total = "";
            this.cantidad = "";
            this.reunion = "";
            this.estado = "";
            this.estados = [];
            this.direcciones = [];
            this.direccion = "";
            this.correos = "";
            this.destinatarios = [];
            this.entregas = [];
            this.detalleoc = [];
            this.comercial = [];
            this.listentrega = [];
            this.listoc = [];
            this.listadop = [];
            this.dialogDelete = false;
            this.editedIndex = -1;
            this.editedItem = {};
            this.mostrarobra = false;
            this.ubicacion = "";
            this.obra = "";
            this.descripcion = "";
            this.comitente = "";
            this.montoobra = "";
            this.plazoobra = "";
            this.adendamonto = "";
            this.adendaplazo = "";
            this.fechacontrato = "";
            this.fechainicio = "";
            this.fechafinal = "";
            this.participacion = "";
            this.especialidad1 = "";
            this.especialidad2 = "";
            this.itemespecialidad = [];
            this.porcespec1 = "";
            this.porcespec2 = "";
            this.antecobra = [];
            this.descr = "";
            //this.fecha = "";
            this.cantidad = "";
            this.tipo = "";
            this.numot = "";
            this.r1 = "";
            this.r2 = "";
            this.r3 = "";
            this.r4 = "";
            this.r5 = "";
            this.r6 = "";
            this.r7 = "";
            this.r8 = "";
            this.r9 = "";
            this.r10 = "";
            this.r11 = "";
            this.r12 = "";
            this.r13 = "";
            this.r14 = "";
            this.r15 = "";
            this.r16 = "";
            this.r17 = "";
            this.e1 = "";
            this.e2 = "";
            this.e3 = "";
            this.e4 = "";
            this.e5 = "";
            this.e6 = "";
            this.e7 = "";
            this.e8 = "";
            this.e9 = "";
            this.e10 = "";
            this.e11 = "";
            this.e12 = "";
            this.e13 = "";
            this.e14 = "";
            this.e15 = "";
            this.protocolo1 = "";
            this.protocolo2 = "";
            this.protocolo3 = "";
            this.protocolo4 = "";
            this.protocolo5 = "";
            this.listado = [];
            this.listadodespacho = [];
            //this.fecha = "";
            this.fechaentrega = "";
            this.prorroga = "";
            this.listadoprorroga = [];
            this.fechaprorroga = "";
            this.diasprorroga = "";
            this.respobra = "";
            this.respprod = "";
            this.lider = "";
            this.calidad = "";
            this.contactocalidad = "";
            this.mailcalidad = "";
            this.telcalidad = "";
            this.numotdesde = "";
            this.numothasta = "";
            this.carpeta = "";
            this.codobra = "";
            this.minuta = "";
            this.despacho = "";
            this.estado = "";
            this.listadoestado = [];
            this.estados = [];
            this.deshabilitar = false;
            this.expanded = [];
            this.correos = "";
            this.destinatarios = [];
            this.montoasegurado = "";
            this.poliza = "";
            this.$router.push({ name: "LanzamientoMain" });

        },
    },
    beforeMount() {
        this.codgral = this.$route.query.codgral;
        this.codoc = this.$route.query.codoc;
        this.cargardatosOC();
        this.cargardatosEjecucion();
        this.cargardatosCalidad();
        this.cargardatosAbastecimiento();

        return this.visible;
    },
};
</script>